module.exports = __webpack_public_path__ + "img/chat_icon3.e171e3f5.png";